<template>
  <div class="list-item__date">
    <span class="list-item__header">期間</span>

    <!-- '利用開始日~利用終了日' -->
    <span class="list-item-value">
      {{ displayUsageDatetime(start) }} ~ {{ displayUsageDatetime(limit) }}
    </span>
  </div>
</template>

<script>
import moment from "@/services/moment";

export default {
  name: "BgMyticketAvailablePeriod",
  props: {
    start: {
      type: String,
      required: true,
    },
    limit: {
      type: String,
      required: true,
    },
  },
  setup() {
    const displayUsageDatetime = (time_stamp) => {
      return moment(new Date(time_stamp)).format("YYYY/MM/DD");
    };

    return {
      displayUsageDatetime,
    };
  },
};
</script>

<style lang="scss" scoped>
.list-item__date {
  font-size: 2vw;
  position: absolute;
  top: 60%;
  color: #777777;
  font-weight: bold;
  width: 100%;
}
.list-item__header {
  font-size: 3vw;
  width: 20%;
  display: inline-block;
}
.list-item-value {
  font-size: 3vw;
  font-weight: bold;
}

@media screen and (min-width: 421px) {
  .list-item__date {
    top: 50%;
  }
}
</style>
